import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { editFeaturesGroup, 
        editCards, 
        popUpMessageChange, 
        editFigures, 
        popUpMenuChange} from '../../actions/index.js';

import { Button } from '@material-ui/core';

import { _ } from '../../functions/translator.js';
import { postData } from '../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../functions/map/reloadCardsGroups';
import { showMessage } from '../../functions/popUpMessage.js';

class DateChangeConfirmation extends React.Component{

    handleClose = () => {
        this.props.onCancel();
        this.props.popUpMessageChange({ show: false })
    }

    handleConfirm = async () => {
        showMessage(this.props, _('Cambiando la fecha del Protocolo') + '...', { loading: true });
        let urlPost = {
            'cards_group_id': this.props.cardsGroupId,
            'start_date': new Date(this.props.task.start_date).toISOString().split('T')[0],
            'finish_date': new Date(this.props.task.end_date).toISOString().split('T')[0],
        }
        let response = await postData('/update-cards-group-dates', urlPost);
        this.handleResponse(response);
        this.props.popUpMenuChange({ 
            show: true,
        });
    }

    handleResponse = (response) => {
        if (response.status === 'success') {
            this.props.onConfirm();
            showMessage(this.props, '¡' + _('Estado del protocolo modificado exitosamente') + '!', {messageTime:2000});
            reloadCardsGroupsFeatures(this.props, [this.props.cardsGroupId]);
        } else {
            this.props.onCancel();
            showMessage(this.props, _('Ocurrió un error al modificar el estado del protocolo'));
        }
    }

    render(){
        return (
            <div>
                <div className="d-flex justify-content-around mt-4">
                    <Button variant="contained" className='confirm-success-button' onClick={ this.handleConfirm }>
                        { _('Cambiar') }
                    </Button>
                    <Button variant="contained" className='confirm-cancel-button' onClick={ this.handleClose }>
                        { _('Cancelar') }
                    </Button>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        projectData : state.projectData
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        popUpMessageChange : popUpMessageChange,
        popUpMenuChange : popUpMenuChange,
        editCards : editCards,
        editFeaturesGroup : editFeaturesGroup,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(DateChangeConfirmation)